import {
	ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY,
	ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK,
	ROUTE_NAMES_BOARDS_DIRECTORY,
	ROUTE_NAMES_BUSINESS_BOARD,
	ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS,
	ROUTE_NAMES_BUSINESS_REPORTS,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED,
	ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE,
	ROUTE_NAMES_CONNECT_GENERAL,
	ROUTE_NAMES_CONNECT_GENERAL_INVALID,
	ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT,
	ROUTE_NAMES_CONNECT_PROJECT,
	ROUTE_NAMES_DASHBOARDS_DIRECTORY,
	ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE,
	ROUTE_NAMES_FILTERS_DIRECTORY,
	ROUTE_NAMES_FILTERS_DIRECTORY_SECURE,
	ROUTE_NAMES_FORGE_ADMIN,
	ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR,
	ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS,
	ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS,
	ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD,
	ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE,
	ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME,
	ROUTE_NAMES_ISSUE_EMBED,
	ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES,
	ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY,
	ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES,
	ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE,
	ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY,
	ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE,
	ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS,
	ROUTE_NAMES_KNOWLEDGE_HUB_LANDING,
	ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH,
	ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES,
	ROUTE_NAMES_KNOWLEDGE_HUB_SETUP,
	ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS,
	ROUTE_NAMES_OPSGENIE_SCHEDULE,
	ROUTE_NAMES_PEOPLE_INDEX,
	ROUTE_NAMES_PERSONAL_SETTINGS,
	ROUTE_NAMES_POLARIS_IDEAS,
	ROUTE_NAMES_POLARIS_INSIGHTS,
	ROUTE_NAMES_POLARIS_PLAYS,
	ROUTE_NAMES_POLARIS_ROOMS,
	ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION,
	ROUTE_NAMES_PROJECTS_DIRECTORY,
	ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA,
	ROUTE_NAMES_PROJECT_COMPONENTS,
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR,
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC,
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE,
	ROUTE_NAMES_PROJECT_PAGES,
	ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS,
	ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS,
	ROUTE_NAMES_PROJECT_VERSIONS,
	ROUTE_NAMES_RAPIDBOARD,
	ROUTE_NAMES_RAPIDBOARD_BACKLOG,
	ROUTE_NAMES_RAPIDBOARD_BOARD,
	ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED,
	ROUTE_NAMES_RAPIDBOARD_REPORT,
	ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG,
	ROUTE_NAMES_RAPIDBOARD_USER_BOARD,
	ROUTE_NAMES_RAPIDBOARD_USER_REPORT,
	ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR,
	ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT,
	ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE,
	ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT,
	ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA,
	ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT,
	ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT,
	ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2,
	ROUTE_NAMES_SERVICEDESK_BOARDS,
	ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM,
	ROUTE_NAMES_SERVICEDESK_INCIDENTS,
	ROUTE_NAMES_SERVICEDESK_INDEX,
	ROUTE_NAMES_SERVICEDESK_ISSUES,
	ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION,
	ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS,
	ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE,
	ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE,
	ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE,
	ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW,
	ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION,
	ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON,
	ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE,
	ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT,
	ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE,
	ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING,
	ROUTE_NAMES_SERVICEDESK_QUEUES_NEW,
	ROUTE_NAMES_SERVICEDESK_REPORTS,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION,
	ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY,
	ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD,
	ROUTE_NAMES_SERVICEDESK_SERVICES,
	ROUTE_NAMES_SERVICEDESK_SERVICES_NEW,
	ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS,
	ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW,
	ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS,
	ROUTE_NAMES_SERVICE_HUB_SERVICES,
	ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS,
	ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG,
	ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS,
	ROUTE_NAMES_SETTINGS_RECOMMENDATIONS,
	ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS,
	ROUTE_NAMES_SOFTWARE_BACKLOG,
	ROUTE_NAMES_SOFTWARE_BOARDS,
	ROUTE_NAMES_SOFTWARE_CODE,
	ROUTE_NAMES_SOFTWARE_CODE_CLASSIC,
	ROUTE_NAMES_SOFTWARE_SECURITY,
	ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC,
	ROUTE_NAMES_SOFTWARE_DEPLOYMENTS,
	ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC,
	ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR,
	ROUTE_NAMES_SOFTWARE_RELEASE_NOTES,
	ROUTE_NAMES_SOFTWARE_REPORTS,
	ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN,
	ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP,
	ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL,
	ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE,
	ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY,
	ROUTE_NAMES_SOFTWARE_ROADMAP,
	ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC,
	ROUTE_NAMES_SOFTWARE_TIMELINE,
	ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC,
	ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT,
	ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY,
	ROUTE_NAMES_YOUR_WORK,
} from '@atlassian/jira-common-constants/src/spa-routes';

// These are the routes that we want to pre-eval the issue import in the after paint phase
export const PREEVAL_ROUTES = new Set<string>([
	ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY,
	ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK,
	ROUTE_NAMES_BOARDS_DIRECTORY,
	ROUTE_NAMES_BUSINESS_BOARD,
	ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS,
	ROUTE_NAMES_BUSINESS_REPORTS,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE,
	ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED,
	ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE,
	ROUTE_NAMES_CONNECT_GENERAL,
	ROUTE_NAMES_CONNECT_GENERAL_INVALID,
	ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT,
	ROUTE_NAMES_CONNECT_PROJECT,
	ROUTE_NAMES_DASHBOARDS_DIRECTORY,
	ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE,
	ROUTE_NAMES_FILTERS_DIRECTORY,
	ROUTE_NAMES_FILTERS_DIRECTORY_SECURE,
	ROUTE_NAMES_FORGE_ADMIN,
	ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR,
	ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS,
	ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS,
	ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW,
	ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES,
	ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD,
	ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE,
	ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME,
	ROUTE_NAMES_ISSUE_EMBED,
	ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES,
	ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY,
	ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES,
	ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE,
	ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY,
	ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE,
	ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS,
	ROUTE_NAMES_KNOWLEDGE_HUB_LANDING,
	ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH,
	ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES,
	ROUTE_NAMES_KNOWLEDGE_HUB_SETUP,
	ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS,
	ROUTE_NAMES_OPSGENIE_SCHEDULE,
	ROUTE_NAMES_PEOPLE_INDEX,
	ROUTE_NAMES_PERSONAL_SETTINGS,
	ROUTE_NAMES_POLARIS_IDEAS,
	ROUTE_NAMES_POLARIS_INSIGHTS,
	ROUTE_NAMES_POLARIS_PLAYS,
	ROUTE_NAMES_POLARIS_ROOMS,
	ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION,
	ROUTE_NAMES_PROJECTS_DIRECTORY,
	ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA,
	ROUTE_NAMES_PROJECT_COMPONENTS,
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR,
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC,
	ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE,
	ROUTE_NAMES_PROJECT_PAGES,
	ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS,
	ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS,
	ROUTE_NAMES_PROJECT_VERSIONS,
	ROUTE_NAMES_RAPIDBOARD,
	ROUTE_NAMES_RAPIDBOARD_BACKLOG,
	ROUTE_NAMES_RAPIDBOARD_BOARD,
	ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED,
	ROUTE_NAMES_RAPIDBOARD_REPORT,
	ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG,
	ROUTE_NAMES_RAPIDBOARD_USER_BOARD,
	ROUTE_NAMES_RAPIDBOARD_USER_REPORT,
	ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR,
	ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT,
	ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE,
	ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT,
	ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA,
	ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT,
	ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT,
	ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2,
	ROUTE_NAMES_SERVICEDESK_BOARDS,
	ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM,
	ROUTE_NAMES_SERVICEDESK_INCIDENTS,
	ROUTE_NAMES_SERVICEDESK_INDEX,
	ROUTE_NAMES_SERVICEDESK_ISSUES,
	ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION,
	ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS,
	ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE,
	ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE,
	ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE,
	ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING,
	ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW,
	ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION,
	ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON,
	ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE,
	ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT,
	ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE,
	ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING,
	ROUTE_NAMES_SERVICEDESK_QUEUES_NEW,
	ROUTE_NAMES_SERVICEDESK_REPORTS,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION,
	ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY,
	ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE,
	ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD,
	ROUTE_NAMES_SERVICEDESK_SERVICES,
	ROUTE_NAMES_SERVICEDESK_SERVICES_NEW,
	ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS,
	ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW,
	ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS,
	ROUTE_NAMES_SERVICE_HUB_SERVICES,
	ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS,
	ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG,
	ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS,
	ROUTE_NAMES_SETTINGS_RECOMMENDATIONS,
	ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS,
	ROUTE_NAMES_SOFTWARE_BACKLOG,
	ROUTE_NAMES_SOFTWARE_BOARDS,
	ROUTE_NAMES_SOFTWARE_CODE,
	ROUTE_NAMES_SOFTWARE_CODE_CLASSIC,
	ROUTE_NAMES_SOFTWARE_SECURITY,
	ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC,
	ROUTE_NAMES_SOFTWARE_DEPLOYMENTS,
	ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC,
	ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR,
	ROUTE_NAMES_SOFTWARE_RELEASE_NOTES,
	ROUTE_NAMES_SOFTWARE_REPORTS,
	ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN,
	ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP,
	ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL,
	ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE,
	ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY,
	ROUTE_NAMES_SOFTWARE_ROADMAP,
	ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC,
	ROUTE_NAMES_SOFTWARE_TIMELINE,
	ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC,
	ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT,
	ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY,
	ROUTE_NAMES_YOUR_WORK,
]);

export const AFTER_PAINT_ISSUE_PREEVAL_MARK = 'AfterPaintIssuePreEval:rendered';
